import React, { useEffect, useState } from 'react';
import AdjustAmountField from './adjustAmountField';
import { numericRegex, ADJUST_ITEM_MODAL_CONSTANTS } from '../../../../../../constants/constant';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../ui/customSelect/customSelect';

const AdjustLineItems = ({ Texts, rowIndex, setAdjustItems, adjustItems, rowData }: any) => {
  const [adjustmentType, setAdjustmentType] = useState('');
  const [reason, setReason] = useState('');
  const [adjustmentValue, setAdjustmentValue] = useState('');
  const [error, setError] = useState('');
  const [calculatedAmount, setCalculatedAmount] = useState('$0.00');

  const handleAdjustmentTypeChange = (value: any) => {
    setAdjustmentType(value);
    updateAdjustItems({
      adjType: value,
      lineSequence: rowData?.lineSequence,
      itemNumber: rowData?.itemNumber,
      productName: rowData?.productDetails,
    });
  };

  const handleReasonChange = (value: any) => {
    setReason(value);
    updateAdjustItems({ reasonDescription: value, showReasonError: false });
  };

  const handleAdjustmentValueChange = (e: any) => {
    const inputValue = e.target.value;
    const isValidInput = numericRegex.test(inputValue) && inputValue.length <= 10;

    if (!isValidInput) return;

    setAdjustmentValue(inputValue);
    validateAndUpdateAdjustItems(inputValue);
  };

  const validateAndUpdateAdjustItems = (inputValue: any) => {
    const subtotal = rowData?.totalPrice;
    const adjustmentAmount =
      adjustmentType === Texts.percentOff ? (subtotal * (inputValue / 100)).toFixed(2) : inputValue;
    if (adjustmentType === Texts.percentOff) {
      setCalculatedAmount(adjustmentAmount);
    }
    if (parseFloat(adjustmentAmount) > rowData?.itemPrice) {
      setError(Texts.adjustAmountError);
      updateAdjustItems({ showError: true });
    } else if (!inputValue) {
      setError(Texts.valueError);
      updateAdjustItems({ showError: true });
    } else {
      setError('');
      updateAdjustItems({
        showError: false,
        previousPrice: rowData?.itemPrice,
        unitPrice: adjustmentAmount,
      });
    }
  };

  const updateAdjustItems = (updatedValues: any) => {
    const adjusts = [...adjustItems];
    adjusts[rowIndex ?? 0] = { ...adjusts[rowIndex], ...updatedValues };
    setAdjustItems(adjusts);
  };

  useEffect(() => {
    if (adjustmentType) {
      validateAndUpdateAdjustItems(adjustmentValue);
    }
    if (adjustmentType === Texts.itemPrice) {
      setAdjustmentValue(rowData?.itemPrice);
      validateAndUpdateAdjustItems('');
      setError('');
    } else {
      setAdjustmentValue('');
      validateAndUpdateAdjustItems('');
      setCalculatedAmount('0.00');
    }
  }, [adjustmentType]);

  return (
    <div className="flex flex-col gap-4">
      <Select onValueChange={handleAdjustmentTypeChange} value={adjustmentType}>
        <SelectTrigger className="mr-2 w-60">
          <SelectValue placeholder="Select Adjustment" />
        </SelectTrigger>
        <SelectContent className="w-60 bg-white px-4">
          {ADJUST_ITEM_MODAL_CONSTANTS.ADJUSTMENTS.map((adjustment) => (
            <SelectItem key={adjustment.value} value={adjustment.value}>
              {adjustment.value}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {adjustmentType && (
        <>
          <section className="flex items-center gap-4">
            {(adjustmentType === Texts.dollarOff || adjustmentType === Texts.itemPrice) && <div>$</div>}
            <section className="w-32">
              <AdjustAmountField
                id={`adjustAmount${rowData?.lineSequence}`}
                htmlFor={`adjustAmount${rowData?.lineSequence}`}
                label="Adjust Amount"
                items={adjustmentType}
                onChange={handleAdjustmentValueChange}
                value={adjustmentValue}
                errors={{ [`adjustAmount${rowData?.lineSequence}`]: error }}
                classname="w-32 rounded-md h-[50px] gbunmask"
                maxLength={10}
              />
            </section>
            {adjustmentType === Texts.percentOff && <div>%</div>}
            {adjustmentType === Texts.percentOff && <div>${calculatedAmount}</div>}
          </section>
          {error && <section className="w-60 font-semibold text-scarletRed">{error}</section>}
        </>
      )}

      <Select onValueChange={handleReasonChange} value={reason}>
        <SelectTrigger
          className={`mr-2 w-60 ${
            !adjustItems[rowIndex]?.reasonDescription && adjustItems[rowIndex]?.showReasonError
              ? 'border-scarletRed text-scarletRed'
              : ''
          }`}
        >
          <SelectValue placeholder="Select Reason" />
        </SelectTrigger>
        <SelectContent className="w-60 bg-white px-4">
          {ADJUST_ITEM_MODAL_CONSTANTS.REASONS.map((reason) => (
            <SelectItem key={reason.value} value={reason.value}>
              {reason.value}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {adjustItems[rowIndex]?.showReasonError && !adjustItems[rowIndex]?.reasonDescription ? (
        <section className="w-60 font-semibold text-scarletRed">{Texts.SelectReason}</section>
      ) : (
        <></>
      )}
    </div>
  );
};

export default AdjustLineItems;
